export function index(archived) {
    return axios.get(route('api.manage.companies.campaigns') +
        '?include=job,applications&filter[archived]=' + (archived ? 'true' : 'false')
    ).then((response) => {
        return response.data;
    });
}

export function brockmeyerStatus(campaigns) {
    return axios.post(route('api.manage.companies.campaigns.brockmeyer.status'), campaigns).then((response) => {
        return response.data;
    });
}

export function show(id) {
    return axios.get(route('api.manage.campaigns.show', {campaignId: id}) + '?include=job,channels')
        .then(response => response.data);
}

export function store(data) {
    return axios.post(route('api.manage.companies.campaigns.store'), data)
        .then(response => response.data);
}

export function update(id, data) {
    return axios.patch(route('api.manage.campaigns.update', {campaignId: id}), data)
        .then(response => response.data);
}

export function republish(id)
{
    return axios.post(route('api.manage.companies.campaigns.republish', {campaignId: id}))
        .then(({data}) => data);
}
export function destroy(id) {
    return axios.delete(route('api.manage.campaigns.destroy', {campaignId: id}));
}

export function createCompany(data) {
    return axios.post(route('api.manage.companies.campaigns.createCompany'), data)
        .then(response => response.data);
}

export function educations(search, ids = '') {
    if (ids)
        ids = '&ids[]=' + ids.join('&ids[]=') + '&';
    else
        ids = ''

    if (search)
        search = 'search=' + search + '&';
    else
        search = '';

    return axios.get(route('api.manage.companies.campaigns.educations') + '?' + search + ids)
        .then(response => response.data);
}

export function regions(search, ids = '') {
    if (ids)
        ids = '&ids[]=' + ids.join('&ids[]=') + '&';
    else
        ids = ''

    if (search)
        search = 'search=' + search + '&';
    else
        search = '';

    return axios.get(route('api.manage.companies.campaigns.regions') + '?' + search + ids)
        .then(response => response.data);
}

export function profiles(search, ids = '') {
    if (ids)
        ids = '&ids[]=' + ids.join('&ids[]=') + '&';
    else
        ids = ''

    if (search)
        search = 'search=' + search + '&';
    else
        search = '';

    return axios.get(route('api.manage.companies.campaigns.profiles') + '?' + search + ids)
        .then(response => response.data);
}

export function sectors(search, ids = '') {
    if (ids)
        ids = '&ids[]=' + ids.join('&ids[]=') + '&';
    else
        ids = ''

    if (search)
        search = 'search=' + search + '&';
    else
        search = '';

    return axios.get(route('api.manage.companies.campaigns.sectors') + '?' + search + ids)
        .then(response => response.data);
}

export function levels(search, ids = '') {
    if (ids)
        ids = '&ids[]=' + ids.join('&ids[]=') + '&';
    else
        ids = ''

    if (search)
        search = 'search=' + search + '&';
    else
        search = '';

    return axios.get(route('api.manage.companies.campaigns.levels') + '?' + search + ids)
        .then(response => response.data);
}

export function channelTypes(search, ids = '') {
    if (ids)
        ids = '&ids[]=' + ids.join('&ids[]=') + '&';
    else
        ids = ''

    if (search)
        search = 'search=' + search + '&';
    else
        search = '';

    return axios.get(route('api.manage.companies.campaigns.channel-types') + '?' + search + ids)
        .then(response => response.data);
}

export function fetchJobBoardData() {
    return axios.get(route('api.manage.companies.campaigns.job-board-data'))
        .then(({data}) => data);
}

export function fetchProductJobs({productId, jobIds}) {
    return axios.get(route('api.manage.companies.campaigns.product-jobs', {productId}) + '?jobIds=' + jobIds.join(','))
        .then(({data}) => data);
}

export function deleteDraft(id) {
    return axios.delete(route('api.manage.companies.campaigns.deleteDraft', {campaignId: id}))
        .then(({data}) => data);
}